export default "__VITE_ASSET__285013a9__"